"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Theme = _interopRequireDefault(require("../../assets/Theme7.css"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _dxcFlex = _interopRequireDefault(require("dxc-flex"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var cx = _bind["default"].bind(_Theme["default"]);

var Button = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(Button, _React$PureComponent);

  function Button() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = Button.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        onClick = _this$props.onClick,
        children = _this$props.children,
        src = _this$props.src,
        disableTip = _this$props.disableTip,
        isHover = _this$props.isHover,
        onMouseOver = _this$props.onMouseOver,
        onMouseOut = _this$props.onMouseOut,
        ui = _this$props.ui; // const borderColor = ui?.btnActiveColor || "250, 100, 0, 1";

    return /*#__PURE__*/_react["default"].createElement(_dxcFlex["default"], {
      horizontal: "center",
      className: cx("Theme7ButtonWp"),
      "data-tip": disableTip ? null : children
    }, /*#__PURE__*/_react["default"].createElement(_dxcFlex["default"], {
      onMouseOver: onMouseOver,
      onMouseOut: onMouseOut,
      layout: "vertical",
      vertical: "center",
      horizontal: "center",
      onClick: onClick,
      className: cx("Theme7Button"),
      style: {
        borderColor: isHover ? ui == null ? void 0 : ui.btnActiveColor : "transparent"
      }
    }, src ? /*#__PURE__*/_react["default"].createElement("img", {
      src: src,
      alt: "",
      className: cx("Theme7LinkIcon")
    }) : null, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        color: isHover ? ui.fontAvtiveColor : ui.fontColor
      },
      className: cx("Theme7ButtonName")
    }, children)));
  };

  return Button;
}(_react["default"].PureComponent);

var _default = Button;
exports["default"] = _default;
module.exports = exports.default;